import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Clock, ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(()=>{ api.get(`/blog/${slug}`).then(r=>setP(r.data)).catch(()=>{}); }, [slug]);

  if (!p) return <div className="min-h-screen"><Navbar/><div className="p-20 text-center text-slate-500">Loading…</div></div>;

  return (
    <div className="min-h-screen">
      <Navbar/>
      <article className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
        <Link to="/blog" className="text-xs inline-flex items-center gap-2 text-slate-500 hover:brand-navy mb-8"><ArrowLeft size={14}/> Back to journal</Link>
        <div className="flex items-center gap-3 text-xs text-slate-500 mb-4">
          <span className="uppercase tracking-widest gold-text">{p.category}</span>
          <span>·</span>
          <span className="inline-flex items-center gap-1"><Clock size={12}/>{p.read_time} min read</span>
        </div>
        <h1 className="font-serif text-4xl md:text-5xl tracking-tighter-x brand-navy leading-[1.1] mb-6">{p.title}</h1>
        <p className="text-slate-500 text-sm mb-10">By {p.author}</p>
        {p.hero_image && <img src={p.hero_image} alt={p.title} className="w-full h-80 object-cover rounded-xl mb-10 border border-slate-200"/>}
        <div className="prose-brand text-slate-700 text-lg leading-relaxed">
          {p.body.split("\n\n").map((para,i) => (
            <p key={i} dangerouslySetInnerHTML={{__html: para.replace(/\*\*(.+?)\*\*/g,'<strong>$1</strong>')}}/>
          ))}
        </div>
      </article>
      <Footer/>
    </div>
  );
}
